var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 608,
    viewBox: "0 0 92 608",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.5 40.5231V535.477C92.12 531.977 91.5956 528.763 90.872 525.597C88.5414 515.403 84.6938 505.616 79.4577 496.563C73.5532 486.355 65.2848 477.465 48.8705 459.815L48.8161 459.756L44.9161 455.563C28.435 437.841 20.2493 429.035 14.4079 418.936C9.22194 409.97 5.41114 400.277 3.10289 390.18C0.502918 378.807 0.5 366.784 0.5 342.583V288V233.417C0.5 209.216 0.502918 197.193 3.10289 185.82C5.41114 175.723 9.22194 166.03 14.4079 157.064C20.2493 146.965 28.435 138.159 44.9161 120.437L48.8161 116.244L48.871 116.185C65.285 98.5353 73.5533 89.6447 79.4577 79.4368C84.6938 70.3844 88.5414 60.5973 90.872 50.4027C91.5956 47.2372 92.12 44.0227 92.5 40.5231Z",
    fill: "white",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle32);
export default __webpack_public_path__ + "static/media/Rectangle 3 (2).caaeee3684f3d0926b343cfe82313381.svg";
export { ForwardRef as ReactComponent };